// extracted by mini-css-extract-plugin
export default {"userRoleSelect":"UserTable_userRoleSelect__wMLsT","userRoleMenu":"UserTable_userRoleMenu__bsNrl"};